import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useFragment } from 'react-relay/hooks';

import { Theme } from '@material-ui/core';
import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';
import { graphql } from 'babel-plugin-relay/macro';
import PatientJourney from 'embeds/components/PatientJourney';
import moment from 'moment';

import { loadPatientJourney } from 'containers/App/actions';
import { makeSelectPatientJourney } from 'containers/App/selectors';
import usePermissions from 'hooks/usePermissions';

import { HubPatientJourney_EmbedPatient$key } from './__generated__/HubPatientJourney_EmbedPatient.graphql';

export const styles = ({ spacing: { unit } }: Theme) =>
  createStyles({
    journeyContent: {
      boxShadow: 'inset 4px 0px 16px rgba(0, 0, 0, 0.1)',
      padding: unit * 3,
      height: '100%',
      overflow: 'auto',
    },
  });

interface HubPatientJourneyProps extends WithStyles<typeof styles> {
  fragmentRef: HubPatientJourney_EmbedPatient$key;
}

const HubPatientJourney: React.FC<HubPatientJourneyProps> = ({ classes, fragmentRef }) => {
  const { permissions } = usePermissions();
  const patient = useFragment<HubPatientJourney_EmbedPatient$key>(
    graphql`
      fragment HubPatientJourney_EmbedPatient on Patient {
        _id
        name
        firstname
        lastname
        master
        dateOfBirth {
          day
          month
          year
        }
      }
    `,
    fragmentRef,
  );
  const dispatch = useDispatch();
  const journey = useSelector(makeSelectPatientJourney());

  const { year, month, day } = patient.dateOfBirth!;
  let dateOfBirthValue;
  let dateOfBirthString;
  if (year && month && day) {
    dateOfBirthValue = moment()
      .year(year)
      .month(Number(month) - 1)
      .date(day);
    dateOfBirthString = dateOfBirthValue.format('MM/DD/YYYY');
  }

  return (
    <div className={classes.journeyContent}>
      {/*
      // @ts-ignore */}
      <PatientJourney
        permissions={permissions!}
        patient={{
          ...patient,
          dateOfBirthValue,
          dateOfBirth: dateOfBirthString,
        }}
        journey={journey}
        singleline
        loadPatientJourney={(id, rangeBy) => dispatch(loadPatientJourney(id, rangeBy, rangeBy === 'days'))}
      />
    </div>
  );
};

export default withStyles(styles)(HubPatientJourney);
